module.exports = __webpack_public_path__ + "media/images/icons/icon_language_checked-a526e9af6357086e2c374aa3e4d34750.svg";